/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/**
 * Gets the image source given the image name.
 *
 * @param name the image name
 * @returns the image source
 */
export const getImageSrc = (name: string, format?: string) => `assets/images/languageStudio/${name}.${format ?? 'svg'}`;
